export const PROMO_CODE_VALIDATION_ATTEMPT = 'PROMO_CODE_VALIDATION_ATTEMPT';
export const PROMO_CODE_VALIDATION_SUCCESS = 'PROMO_CODE_VALIDATION_SUCCESS';
export const PROMO_CODE_INVALID = 'PROMO_CODE_INVALID';
export const PROMO_CODE_VALIDATION_FAILURE = 'PROMO_CODE_VALIDATION_FAILURE';
export const PROMO_CODE_VALIDATION_CLEAR_STATE = 'PROMO_CODE_VALIDATION_CLEAR_STATE';
export const PROMO_CODE_PREDEFINED_CODES = 'PROMO_CODE_PREDEFINED_CODES';
export const PROMO_CODE_REFRESH_ATTEMPT = 'PROMO_CODE_REFRESH_ATTEMPT';
export const PROMO_CODE_REMOVE_CODE = 'PROMO_CODE_REMOVE_CODE';
export const CLEAR_STATE = 'CLEAR_STATE';
